import { Drawer, IconButton, DialogTitle, DialogContent } from "@mui/material"
import { Close } from "@mui/icons-material"

import useAppStore from "store/app"

const BottomDrawer = (props) => {
  const { children } = props

  const { open_drawer, direction } = useAppStore((state) => state.meta)
  const toggleDrawer = useAppStore((state) => state.toggleDrawer)

  return (
    <Drawer
      open={open_drawer}
      anchor="bottom"
      dir={direction}
      // onClose={() => toggleDrawer(false)}
      PaperProps={{
        style: {
          maxWidth: "450px",
          margin: "auto",
          backgroundColor: "#F1F4F9",
          borderTopLeftRadius: 16, // Adjust the radius as needed
          borderTopRightRadius: 16, // Adjust the radius as needed
          height: "97vh", // Adjust the height as needed
        },
      }}
    >
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => toggleDrawer(false)}
          sx={{
            // position: "absolute",
            // right: 8,
            // zIndex: 10,
            // top: 8,
            color: (theme) => theme.palette.grey[700],
            backgroundColor: (theme) => theme.palette.grey[300],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Drawer>
  )
}

export default BottomDrawer
